export default __webpack_public_path__ + "static/media/meritz_img02.3b82312f.png";